import { printTable } from "utils/printTable"
import jsPDF from "jspdf";
import { printTopRight } from "branch/functions/pirntTopRight";
import { printHeader } from "branch/functions/pirntHeader";
import { numberFormat, sortObj } from "utils";
import { printIncomeColumns } from "./columnsPrintExp";
import { green, red } from "@mui/material/colors";

export const printShippingExpense = ({ msData, shpData }) => {

  console.log("printShippingExpense", shpData)

  const pageSize = [8.3, 11.7];
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "in",
    format: pageSize
  });

  const startY = 0.3
  const startX = 0.3
  const lineHeight = 0.21
  const contentSize = 14;
  const MAX_ROW = 35;
  let yPos = startY
  let xPos = startX

  doc.setLineWidth(0.01)
  doc.setFont("THSarabun")

  const { Scs, Exps, Itms } = shpData
  const itms = [
    ...Itms.map(item => ({
      ...item,
      IsOwnRcpt: item.IsCost,
      Qty: item.Qty || 1,
      Total: item.Amnt
    })),
    ...Scs]
  const exps = [...Exps]

  const groupedItms = []
  for (const itm of itms) {
    const found = groupedItms.find(item => item.ExpNm === itm.ExpNm && item.IsOwnRcpt === itm.IsOwnRcpt)
    if (found) {
      found.Qty += itm.Qty || 0
      found.Total += itm.Total || 0
    } else {
      groupedItms.push({ ...itm })
    }
  }
  const groupedExps = []
  for (const exp of exps) {
    const found = groupedExps.find(item => item.ExpNm === exp.ExpNm && item.IsOwnRcpt === exp.IsOwnRcpt)
    if (found) {
      found.Qty += exp.Qty || 0
      found.Total += exp.Total || 0
    } else {
      groupedExps.push({ ...exp })
    }
  }

  sortObj(groupedItms, "IsOwnRcpt", "ExpNm")
  sortObj(groupedExps, "IsOwnRcpt", "ExpNm")
  let idx = 0
  let sumOwnRcptCost = 0
  let sumCusRcptCost = 0
  for (const itm of groupedItms) {
    idx++
    itm.id = idx
    itm.No = idx
    itm.OwnRcptAmnt = itm.IsOwnRcpt ? +itm.Total : null
    itm.CusRcptAmnt = itm.IsOwnRcpt ? null : +itm.Total
    if (itm.IsOwnRcpt) {
      sumOwnRcptCost += +itm.Total
    } else {
      sumCusRcptCost += +itm.Total
    }
  }
  let numCost = idx

  idx = 0
  let sumOwnRcptInc = 0
  let sumCusRcptInc = 0
  for (const itm of groupedExps) {
    idx++
    itm.id = idx
    itm.No = idx
    itm.OwnRcptAmnt = itm.IsOwnRcpt ? +itm.Total : null
    itm.CusRcptAmnt = itm.IsOwnRcpt ? null : +itm.Total
    if (itm.IsOwnRcpt) {
      sumOwnRcptInc += itm.Total
    } else {
      sumCusRcptInc += itm.Total
    }
  }
  let numInc = idx

  if (numCost > numInc) {
    let diff = numCost - numInc
    for (let i = 0; i < diff; i++) {
      groupedExps.push({
        id: -1,
        No: "-",
        ExpNm: "-",
        Qty: "-",
        CusRcptAmnt: null,
        OwnRcptAmnt: null
      })
    }
  } else {
    let diff = numInc - numCost
    for (let i = 0; i < diff; i++) {
      groupedItms.push({
        id: -1,
        No: "-",
        ExpNm: "-",
        Qty: "-",
        CusRcptAmnt: null,
        OwnRcptAmnt: null
      })
    }
  }
  groupedItms.push({
    id: 0,
    No: "",
    ExpNm: "Total",
    Qty: "",
    CusRcptAmnt: sumCusRcptCost,
    OwnRcptAmnt: sumOwnRcptCost,
  })
  groupedExps.push({
    id: 0,
    No: "",
    ExpNm: "Total",
    Qty: "",
    CusRcptAmnt: sumCusRcptInc,
    OwnRcptAmnt: sumOwnRcptInc,
  })

  console.log("groupedItms", groupedItms)
  const maxRow = Math.max(groupedItms.length, groupedExps.length);
  const numPage = Math.ceil(maxRow / MAX_ROW)

  for (let i = 0; i < numPage; i++) {
    if (i > 0) {
      doc.addPage(pageSize)
    }
    yPos = startY
    xPos = startX

    const titleObj = {
      label: `รายงานรายได้${numPage > 1 ? `(${i + 1}/${numPage})` : ""}`,
      xPos: 6.2
    }
    const infoObj = {
      xPos: 5.2,
      objs: [
        {
          header: "Customer: ",
          value: `${shpData.CusNm}`,
          headerWidth: 0.7
        },
        {
          header: "JobNo : ",
          value: shpData.JobNo,
          headerWidth: 0.7
        },
        {
          header: `${shpData.ShpmTypId === 1 ? "Booking:" : "B/L No.:"} `,
          value: shpData.Bkg,
          headerWidth: 0.7
        },
        {
          header: "InvNo: ",
          value: `${shpData.InvNo}`,
          headerWidth: 0.7
        },
        {
          header: "Port: ",
          value: `${shpData.Port}`,
          headerWidth: 0.7
        },
      ]
    }
    const yPosTopRight = printTopRight({ jsPDFDoc: doc, titleObj, infoObj, startY: startY + 0.2 })

    yPos = printHeader({ jsPDFDoc: doc, companyData: msData.serverData.CompanyData, startX: xPos, startY: startY })
    yPos = Math.max(yPos, yPosTopRight)

    yPos -= lineHeight

    const printCostDataTable = groupedItms.slice(i * MAX_ROW, (i + 1) * MAX_ROW);
    const printIncDataTable = groupedExps.slice(i * MAX_ROW, (i + 1) * MAX_ROW);

    doc.setFont("THSarabun", "normal")
    printTable({ doc, dataTable: printCostDataTable, columns: printIncomeColumns, startX: startX, startY: yPos, fontSize: contentSize })
    const startIncX = startX + 4.05
    yPos = printTable({ doc, dataTable: printIncDataTable, columns: printIncomeColumns, startX: startIncX, startY: yPos, fontSize: contentSize })
    yPos += lineHeight
    doc.setFont("THSarabun", "bold")
    doc.text("Grand Total", startX + 0.4, yPos)
    doc.text(numberFormat(sumOwnRcptCost + sumCusRcptCost), startX + 3.7, yPos, { align: "right" })
    doc.text("Grand Total", startIncX + 0.4, yPos)
    doc.text(numberFormat(sumOwnRcptInc + sumCusRcptInc), startIncX + 3.7, yPos, { align: "right" })

    yPos += lineHeight + lineHeight / 2
    const profit = sumOwnRcptInc - sumOwnRcptCost
    doc.setFillColor(profit> 0?green[100] : red[100])
    doc.rect(startIncX, yPos - 0.1, 3.7, lineHeight + 0.1, "F")
    // doc.line(startX, yPos - 0.1, startX + dataBoxW, yPos - 0.1)
    yPos += 0.1
    doc.setFontSize(contentSize + 2)
    doc.text("PROFIT", startIncX + 0.4, yPos)
    doc.text(numberFormat(profit), startIncX + 3.7, yPos, { align: "right" })
    doc.line(startIncX + 0.4, yPos + 0.03, startIncX + 3.7, yPos + 0.03)
    doc.line(startIncX + 0.4, yPos + 0.06, startIncX + 3.7, yPos + 0.06)

    yPos += lineHeight*5
    const colWidth = (pageSize[0] - 1)/3
    const paddingLine = 0.4
    const label = ["Prepared By", "Checked By", "Approved By"]
    for(const i of [0, 1, 2]){
      const colX = 0.5 + i * colWidth
      doc.line(colX + paddingLine, yPos, colX + colWidth - paddingLine, yPos)
      doc.text(label[i], colX + colWidth/2, yPos + lineHeight, { align: "center" })
    }
  }

  const blob = new Blob([doc.output('blob')], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  
  // Open in new tab
  window.open(blobUrl, '_blank');
  
  // Clean up memory after a small delay
  ;
}